<template lang="pug">
  div
    .document-request-selector
    .pa-4
      v-row
        h2.primary--text {{ componentHeader }}
      v-row(v-if="!loading")
        v-col.py-2
          .selectors-zone
            v-row
              v-col(cols="6")
                v-select(
                  v-model="requestsEntity",
                  :label="$t('Common.type')",
                  :items="entities",
                  :loading="loading",
                  return-object,
                  item-text="name",
                  item-value="id",
                )
              v-col(cols="6")
                v-select(
                  :v-if="requestsEntity ==! ''"
                  :value="selected",
                  :label="$tc('DocumentRequest._name', 2)", 
                  :items="filteredRequests",
                  :loading="loading",
                  return-object,
                  item-text="name",
                  item-value="id",
                  @input="addDocumentRequest",
                )
            v-row(v-if="setEntityFileId")
              v-col(cols="6")
                v-text-field(
                  v-model="entityFileId",
                  :label="$t('Common.entityId')",
                  @input="updateEntityFileId",
                )
        v-col.py-0(v-if="multiple")
          .table-zone
            v-row
              v-col(cols="12")
                g-data-table.tieTable(
                  :items="selected",
                  :options.sync="options",
                  v-bind="{ headers, loading }",
                  itemKey="id",
                )
                  template(v-slot:item.consecutiveNumber="{ headers, item, index }")
                    span
                  template(v-slot:item.removeDocumentRequest="{ headers, item, index }")
                    v-btn.pa-0(
                      @click="removeDocumentRequest(item)",
                      min-width="30",
                      height="30",
                      color="error",
                    )
                      v-icon(small) mdi-delete


</template>

<script>
import axios from 'axios'

export default {
  name: "DocumentRequestSelector",
  props: ['multiple', 'currentValues', 'setEntityFileId'],
  data() {
    return {
      loading: true,
      requestsEntity: '',
      entityFileId: '',
      selected: null,
      documentRequestsList: [],
      entities: ['Order', 'Shipment'],
      headers: [
        { text: "", value: "consecutiveNumber", sortable: false },
        { text: this.$tc('DocumentRequest._name', 1), value: "name", sortable: false },
        { text: this.$t('Common.entity'), value: "applicableOn", sortable: false },
        { text: "", value: "removeDocumentRequest", sortable: false },
      ],
      options: {},
    }
  },
  computed: {
    filteredRequests() {
      return (this.documentRequestsList) ? this.documentRequestsList.filter(dr => dr.applicableOn === this.requestsEntity) : [];
    },
    componentHeader() {
      return this.multiple ? this.$tc('Email.Attachment', 2) : this.$tc('DocumentRequest._name', 1);
    },
  },
  watch: {
  },
  methods: {
    addDocumentRequest(val) {
      if (this.multiple) {
        //Search for the element in the selected array and push it into the array if doesn't exists there
        const element = this.selected.filter(sr => sr.id === val.id);
        if (element.length == 0) this.selected.push({ id: val.id, applicableOn: val.applicableOn, externalId: val.externalId, name: val.name, entityId: '@Model.Id', entityContext: '@Model._Entity', entityFileId: this.entityFileId });
      }
      else {
        this.selected = { id: val.id, applicableOn: val.applicableOn, externalId: val.externalId, name: val.name, entityFileId: this.entityFileId };
      }

      this.updateList(this.selected);
    },
    updateEntityFileId(val) {
      this.selected = { ...this.selected, entityFileId: val };
      this.updateList(this.selected);
    },
    removeDocumentRequest(val) {
      //Remove the selected element from the array
      this.selected = _.remove(this.selected, function (n) {
        return n.id !== val.id;
      });
      this.updateList(this.selected);
    },
    updateList(val) {
      this.$emit('input', val);
    }
  },
  async created() {
    try {
      this.documentRequestsList = (await axios.get("/documentRequest/", {
                    params: {
                      pageSize: 1000
                    }
                })).data.data;
      this.requestsEntity = this.currentValues.applicableOn;
      this.entityFileId = this.currentValues.entityFileId;
      if (!this.multiple) {
        let docRequestItem;
        if (this.currentValues.externalId != null) {
          docRequestItem = this.documentRequestsList.filter(x => x.externalId === this.currentValues.externalId);
        } else if (this.currentValues.id != null) {
          docRequestItem = this.documentRequestsList.filter(x => x.id === this.currentValues.id);
        }
        this.selected = (docRequestItem && docRequestItem.length > 0) ? docRequestItem[0] : {};
      }
      else {
        this.selected = this.currentValues;
      }
    }
    catch (error) {
      console.log("REQUEST ERROR: ", this.$cleanString(error));
    }
    finally {
      if (!this.selected) {
        this.selected = this.multiple ? [] : {};
      }
      this.loading = false;
    }
  },
}
</script>
